import { render, staticRenderFns } from "./Wisc5.vue?vue&type=template&id=bacea610&lang=true"
import script from "./Wisc5.vue?vue&type=script&lang=js"
export * from "./Wisc5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports